
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateCalculationTemplateGroupDtoFormGroup() {
return new FormGroup({
    calculationTemplateId: new FormControl<number | undefined>(undefined, [Validators.required]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    sortOrder: new FormControl<number | undefined>(undefined),
})
;
}
      